import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Headers, Http, RequestOptions, Response } from '@angular/http';
import { Router } from '@angular/router';
import { DatePickerComponent } from '../../date-picker/date-picker.component';
import { DropdownComponent } from '../../dropdown/dropdown.component';
import { SelectListTypeForCreation } from './../../../communication-structure/select-list-type-for-creation';
import { CommunicationProxyService } from './../../../services/communication-proxy.service';
import { LoginService } from './../../../services/login.service';
import { StringTableService } from './../../../services/string-table.service';
import { AccordionComponent } from './../../accordion/accordion.component';
import { PageViewComponent } from './../../page-view/page-view.component';
import { SelectListComponent } from './../../select-list/select-list.component';
import { ButtonModel } from './../../tg-button/tg-button.component';
import { activeTrainingPageEnum, TrainingManagementComponent } from './../training-management/training-management.component';
import { MainComponent } from '../../main-component/main.component';

@Component({
  selector: 'app-create-auto-training-code',
  templateUrl: './create-auto-training-code.component.html',
  styleUrls: ['./create-auto-training-code.component.scss']
})

export class CreateAutoTrainingCodeComponent extends PageViewComponent implements OnInit {

  public pageTitle: string;
  public pageDesc: string;
  public autoTrainingNameTitle: string;
  public trainingDescriptionTitle: string;
  public startDateTitle: string;
  public endDateTitle: string;
  public autoTrainingCodeNameToEdit: string = "";
  public emailReminderFrequencyTitle: string;
  public trainingListTitle: string;
  public autoTrainingCodeTitle: string;
  public emailReminderFreqOptions = [];
  public selectedFreq: string;
  public isEdit: boolean;
  public isInactivate: boolean;
  public upDownText: string;
  public reactivateBtnVisible = false;
  public defaultCutoffTime: string;
  public snodes: AccordionComponent[] = [];

  public upBtn: ButtonModel = { name: '', icon: '' };
  public downBtn: ButtonModel = { name: '', icon: '' };
  public cancelBtn: ButtonModel = { name: '', icon: '' };
  public createBtn: ButtonModel = { name: '', icon: '' };
  public clientTrainingList: { trainingList: Array<any>, title: any } = { trainingList: [], title: undefined };
  public startDate: { date: string, isDateValid: boolean } = { date: null, isDateValid: false };
  public endDate: { date: string, isDateValid: boolean } = { date: null, isDateValid: false };
  public getClientTrainingListEndPoint: string;
  public createAtcEndPoint: string;
  public isRegistered = false;

  @ViewChild('treeListAccordion') accordion: AccordionComponent;
  @ViewChild('selectList') list: SelectListComponent;
  @ViewChild('TrainingDescription') trainingDesc;
  @ViewChild('TriningName') trainingNameBox;
  @ViewChild('startDate') startDateEl: DatePickerComponent;
  @ViewChild('endDate') endDateEl: DatePickerComponent;
  @ViewChild('emailReminderFreq') emailReminderFreqDD: DropdownComponent;

  @Output() onCancelButtonClicked = new EventEmitter<number>();

  constructor(
    ele: ElementRef,
    remoteProxy: CommunicationProxyService,
    protected loginService: LoginService,
    stringTableService: StringTableService,
    protected router: Router
  ) {
    super(ele, remoteProxy, loginService, stringTableService, router);
    this.emailReminderFreqOptions = [];
    this.isEdit = false;
    this.isInactivate = false;
  }

  ngOnInit() {
    TrainingManagementComponent.setActiveTrainingPage(activeTrainingPageEnum.createAutoTrainingCode);
    this.initialiseView();
    this.getClientTrainingList();
    if (!this.isEdit || this.reactivateBtnVisible) {
      this.trainingNameBox.setFocus();
    }
  }

  initialiseView() {
    this.pageTitle = this.stringTableService.getString('createAutoTrainingCode', 'pageTitle');
    this.pageDesc = this.stringTableService.getString('createAutoTrainingCode', 'pageDesc');
    this.autoTrainingNameTitle = this.stringTableService.getString('createAutoTrainingCode', 'autoTrainingNameTitle');
    this.trainingDescriptionTitle = this.stringTableService.getString('createAutoTrainingCode', 'trainingDescriptionTitle');
    this.startDateTitle = this.stringTableService.getString('createAutoTrainingCode', 'startDateTitle');
    this.endDateTitle = this.stringTableService.getString('createAutoTrainingCode', 'endDateTitle');
    this.emailReminderFrequencyTitle = this.stringTableService.getString('createAutoTrainingCode', 'emailReminderFrequencyTitle');
    this.trainingListTitle = this.stringTableService.getString('createAutoTrainingCode', 'trainingListTitle');
    this.autoTrainingCodeTitle = this.stringTableService.getString('createAutoTrainingCode', 'autoTrainingCodeTitle');
    this.upBtn.icon = this.stringTableService.getString('icons', 'triangle-up');
    this.upBtn.name = this.stringTableService.getString('labels', 'up');
    this.downBtn.icon = this.stringTableService.getString('icons', 'triangle-down');
    this.downBtn.name = this.stringTableService.getString('labels', 'down');
    this.createBtn.icon = this.stringTableService.getString('icons', 'check');
    this.createBtn.name = this.stringTableService.getString('labels', 'create');
    this.cancelBtn.icon = this.stringTableService.getString('icons', 'x');
    this.cancelBtn.name = this.stringTableService.getString('labels', 'cancel');
    this.emailReminderFreqOptions = this.stringTableService.getArrayOfStrings('createAutoTrainingCode', 'emailReminderFreqOptions');
    this.upDownText = this.stringTableService.getString('createAutoTrainingCode', 'upDownText');
    this.selectedFreq = this.emailReminderFreqOptions[0].name;
    this.getClientTrainingListEndPoint = this.stringTableService.getEndpoint('GetClientTrainingList');
    this.createAtcEndPoint = this.stringTableService.getEndpoint('CreateAtc');
    this.defaultCutoffTime = this.stringTableService.getString('createAutoTrainingCode', 'defaultCutoffTime');
  }

  /**
   * to display accordian dummy data used atc list.
   * change this after training api data is recieved.
   */
  getClientTrainingList() {
    this.getDataFromApi(this.getClientTrainingListEndPoint, { clientId: this.currentUserClientID, systemId: this.systemID })
      .subscribe(
      this.handleClientTrainingListData.bind(this),
      this.handleSubscriptionError.bind(this, this.getClientTrainingList.bind(this), false)
      );
  }

   handleClientTrainingListData(clientTrainingData) {
    this.hideLoader();
    this.clientTrainingList = clientTrainingData;
    MainComponent.setTrainingList(clientTrainingData.trainingList);
  }

  isEnabled(buttonType: BUTTONTYPE): boolean {
    if (buttonType === BUTTONTYPE.RIGHT_NAV) {
      return (this.isRegistered || this.accordion.selectedItems.length === 0);
    } else if(BUTTONTYPE.LEFT_NAV === buttonType) {
      if(this.list.acc === undefined || this.list.acc.selectedItems === undefined) {
        return false;
      } else {
        return (this.isRegistered || this.list.acc.selectedItems.length === 0);
      }
    }
     
    return true; 
  }

  onClick(buttonType: BUTTONTYPE) {
    switch (buttonType) {
      case BUTTONTYPE.RIGHT_NAV: {
        this.addItemsToSelectList();
      }
        break;
      case BUTTONTYPE.LEFT_NAV: {
        this.snodes=[];
        for (const snode of this.list.acc.selectedNodes) {
          if((snode as any).nodes !== undefined) {
            for (const node of (snode as any).nodes) {
              if((node as any).nodes !== undefined) {
                for (const child of (node as any).nodes) {
                  this.snodes.push(child);
                }
              }
              else {
                this.snodes.push(node);
              }
            }
          }
          else {
            for (const snd of (snode as any).root.nodes) {
              for (const node of (snd as any).nodes) {
                for (const child of (node as any).nodes) {
                  if (child.id == snode.id) {
                    this.snodes.push(child);
                  }
                }
              }
            }
          }
        }
        this.list.removeList(Array.from(this.snodes));
        this.list.acc.nodes = this.list.lists;

        this.list.acc.selectedItems.length = 0;
        this.list.acc.clearSelection();
      }
        break;
      case 2: {
        this.list.move(DIRECTION.UP, Array.from(this.list.selectedItems));
      }
        break;
      case 3: {
        this.list.move(DIRECTION.DOWN, Array.from(this.list.selectedItems));
      }
        break;
    }
  }

  onCancelBtnClicked() {
    this.loadHome();
  }

  /**
  * Creates AutoTrainig Code
  */
  createAtc() {
    if (this.isValidate()) {
      const rawDataForCreateAtc = (this.list.lists as SelectListTypeForCreation[]);
      const dataForCreateAtc = {
        clientId: this.currentUserClientID,
        autoTrainingCodeName: this.trainingNameBox.text,
        forceOrder: true,
        description: this.trainingDesc.text,
        creationDate: this.startDate.date,
        expirationDate: this.endDate.date,
        reminderFrequency: this.selectedFreq,
        trainingsInAutoTrainingCodeList: this.prepareDataForCreateAtc(rawDataForCreateAtc, this.defaultCutoffTime)
      };
      this.postDataToApi(this.createAtcEndPoint, dataForCreateAtc)
        .subscribe(
        this.handleCreateAtcSuccess.bind(this),
        this.handleSubscriptionError.bind(this, this.createAtc.bind(this), true)
        );
    }
  }

  getDate(date) {
    if (date !== null) {
      return date;
    }
    return '';
  }

  /**
   * the success handler for the Create AutoTraining Code function
   */
  private handleCreateAtcSuccess(createAtcResponse) {
    this.hideLoader();
    const dataForDialog = {
      title: this.stringTableService.getString('popupMessages', 'atcCreatedTitle'),
      body: this.trainingNameBox.text + this.stringTableService.getString('popupMessages', 'atcCreatedDesc')
    };
    this.validationPopup = true;
    this.showDialog(dataForDialog, () => { this.validationPopup = false; });
    this.resetCreateData();
  }

  clearSelection(event) {
    this.accordion.clearSelection();
  }

  addItemsToSelectList() {
    this.list.addList(this.prapareDataForSelectList(this.accordion));
  }

  handleDblClick() {
    this.addItemsToSelectList();
  }

  resetCreateData() {
    this.list.resetSelectionList();
    this.trainingDesc.resetTextBox();
    this.trainingNameBox.resetTextBox();
    this.startDate = { date: null, isDateValid: false };
    this.endDate = { date: null, isDateValid: false };
    this.startDateEl.datePicker.selectionDayTxt = '';
    this.endDateEl.datePicker.selectionDayTxt = '';
    this.emailReminderFreqDD.textBoxValue = this.emailReminderFreqOptions[0].name;
  }

  isValidate(): boolean {
    let continueValidation = false;
    if (!this.isEdit || this.reactivateBtnVisible) {
      if (this.validateTextboxLength(this.trainingNameBox, true) && this.validateInputChar(this.trainingNameBox)) {
        continueValidation = true;
      }
    } else { continueValidation = true; }
    if (continueValidation) {
      if (this.validateTextboxLength(this.trainingDesc, true) && this.validateInputChar(this.trainingDesc)) {
        if (this.optionalDateValidation(this.startDate, this.endDate)) {
          if (this.selectBoxValidation(this.list)) {
            return true;
          }
        }

      }
    }
    return false;
  }

  onStartDateChanged(event) {
    this.startDate = this.getDateData(event);
  }

  onEndDateChanged(event) {
    this.endDate = this.getDateData(event);
  }

  avoidChar(event) {
    if (event.charCode < 47 || event.charCode > 57) {
      event.preventDefault();
    }
  }
  
  onFrequencyMenuItemChange(event) {
    this.selectedFreq = event.name;
  }
}

export enum DIRECTION {
  UP = 0,
  DOWN = 1
}

enum BUTTONTYPE {
  RIGHT_NAV = 0,
  LEFT_NAV = 1,
  UP = 2,
  DOWN = 3,
  CANCEL = 4,
  SUBMIT = 5
}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/training-management/create-auto-training-code/create-auto-training-code.component.ts